'use client'

import { useCallback, useEffect, useMemo } from 'react'

import { buildResourceGroupTree } from '@modules/project-keys/mappers/buildResourceGroupTree'
import { selectResourceGroups, selectSelectedGroupId } from '@modules/project-keys/stores/project-keys.selector'
import { useProjectKeysStore } from '@modules/project-keys/stores/project-keys.store'
import { fetchGroups } from '@modules/project-keys/stores/project-keys.thunks'
import { selectCurrentProject } from '@modules/projects/stores/projects.selector'
import { useProjectsStore } from '@modules/projects/stores/projects.store'

export const ALL_PROJECT_KEYS_VALUE = 'all'

export const PROJECT_KEY_ENVIRONMENT_ALL_LABEL = 'All project keys'

export function useProjectKeyEnvironmentFilterStore() {
  const currentProject = useProjectsStore(selectCurrentProject)
  const groups = useProjectKeysStore(selectResourceGroups)
  const selectedGroupId = useProjectKeysStore(selectSelectedGroupId)
  const setSelectedGroupId = useProjectKeysStore((state) => state.setSelectedGroupId)

  useEffect(() => {
    if (currentProject?.projectId) {
      void fetchGroups(currentProject.projectId)
    }
  }, [currentProject?.projectId])

  const options = useMemo(
    () => [
      { value: ALL_PROJECT_KEYS_VALUE, label: PROJECT_KEY_ENVIRONMENT_ALL_LABEL },
      ...buildResourceGroupTree(groups).map((group) => ({
        value: group.id,
        label: `${'  '.repeat(group.depth)}${group.name}`,
      })),
    ],
    [groups]
  )

  const value = selectedGroupId ?? ALL_PROJECT_KEYS_VALUE

  const applyValue = useCallback(
    (nextValue: string) => {
      setSelectedGroupId(nextValue === ALL_PROJECT_KEYS_VALUE ? null : nextValue)
    },
    [setSelectedGroupId]
  )

  return { options, value, applyValue, selectedGroupId }
}
